export default __webpack_public_path__ + "static/media/full-logo-white.007c7951.png";